export default __webpack_public_path__ + "static/media/app-img.e04ee558.png";